import React, { useState } from 'react';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import DealForm from './components/DealForm';
import DealPipeline from './components/pipeline/DealPipeline';
import DataRoom from './components/dataroom/DataRoom';
import DueDiligence from './components/duediligence/DueDiligence';
import FinancialModeling from './components/financial/FinancialModeling';
import DocumentGenerator from './components/documents/DocumentGenerator';
import IntegrationDashboard from './components/integration/IntegrationDashboard';
import RiskDashboard from './components/risk/RiskDashboard';
import ComplianceTracker from './components/compliance/ComplianceTracker';
import TeamCollaboration from './components/team/TeamCollaboration';
import StakeholderManager from './components/stakeholders/StakeholderManager';
import EmailDashboard from './components/communications/EmailDashboard';
import ZoomDashboard from './components/communications/ZoomDashboard';
import CalendarDashboard from './components/calendar/CalendarDashboard';
import PipelineAnalytics from './components/analytics/PipelineAnalytics';
import CampaignDashboard from './components/campaigns/CampaignDashboard';
import CommunicationSettings from './components/settings/CommunicationSettings';
import Login from './components/Login';
import { DealsProvider } from './store/DealsContext';
import { AuthProvider } from './store/AuthContext';
import { useAuth } from './store/AuthContext';

export type Path = '/' | '/new-deal' | '/pipeline' | '/data-room' | '/due-diligence' | 
                   '/financial' | '/documents' | '/integration' | '/risk' | '/compliance' |
                   '/team' | '/stakeholders' | '/email' | '/meetings' | '/calendar' |
                   '/analytics' | '/campaigns' | '/settings';

function AppContent() {
  const [currentPath, setCurrentPath] = useState<Path>('/');
  const { user } = useAuth();

  const renderContent = () => {
    switch (currentPath) {
      case '/new-deal':
        return <DealForm />;
      case '/pipeline':
        return <DealPipeline />;
      case '/data-room':
        return <DataRoom />;
      case '/due-diligence':
        return <DueDiligence />;
      case '/financial':
        return <FinancialModeling />;
      case '/documents':
        return <DocumentGenerator />;
      case '/integration':
        return <IntegrationDashboard />;
      case '/risk':
        return <RiskDashboard />;
      case '/compliance':
        return <ComplianceTracker />;
      case '/team':
        return <TeamCollaboration />;
      case '/stakeholders':
        return <StakeholderManager />;
      case '/email':
        return <EmailDashboard />;
      case '/meetings':
        return <ZoomDashboard />;
      case '/calendar':
        return <CalendarDashboard />;
      case '/analytics':
        return <PipelineAnalytics />;
      case '/campaigns':
        return <CampaignDashboard />;
      case '/settings':
        return <CommunicationSettings />;
      default:
        return <Dashboard />;
    }
  };

  if (!user) {
    return <Login />;
  }

  return (
    <DealsProvider>
      <Layout currentPath={currentPath} onNavigate={setCurrentPath}>
        {renderContent()}
      </Layout>
    </DealsProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}